const escapeRegex = (string: string) => string.replace(/[/\-\\^$*+?.()|[\]{}]/g, '\\$&');

export const createSearchRegex = (searchLine: string) => new RegExp(escapeRegex(searchLine.trim()), 'ig');
